var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGw({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512.001 512.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 256H0V97.103a8.829 8.829 0 0 1 8.828-8.828h494.345a8.829 8.829 0 0 1 8.828 8.828L512 256z",
    fill: "#ffe15a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 256h512v158.897a8.829 8.829 0 0 1-8.828 8.828H8.828A8.829 8.829 0 0 1 0 414.897V256z",
    fill: "#73af00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M167.724 88.276v335.448H8.828A8.829 8.829 0 0 1 0 414.896V97.103a8.829 8.829 0 0 1 8.828-8.828h158.896v.001z",
    fill: "#ff4b55"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M82.197 211.959l-9.731 29.18-30.759.238c-1.686.013-2.386 2.165-1.028 3.167l24.744 18.272-9.278 29.326c-.509 1.608 1.322 2.937 2.694 1.958l25.024-17.886 25.024 17.887c1.372.981 3.202-.35 2.694-1.957l-9.278-29.326 24.744-18.272c1.356-1.002.658-3.154-1.028-3.167l-30.759-.238-9.731-29.18c-.536-1.601-2.798-1.601-3.332-.002z",
    fill: "#464655"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGw);
export default __webpack_public_path__ + "static/media/gw.c6f3a31fba8d530b519d669328e123ee.svg";
export { ForwardRef as ReactComponent };